import { FuseAnimate, FuseScrollbars } from '@fuse';
import _ from '@lodash';
import { AppBar, Collapse, DialogActions, DialogContent, DialogTitle, Paper, Slide, Toolbar, Typography, withStyles } from '@material-ui/core';
import XAPPButton from 'app/Core/Components/Button/XAPPButton';
import XAPPDialog from 'app/Core/Components/Dialog/XAPPDialog';
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import * as AppActions from 'app/store/actions';
import withReducer from 'app/store/withReducer';
import clsx from 'clsx';
import MobileDetect from 'mobile-detect';
import React from 'react';
import { connect } from 'react-redux';
import { matchRoutes } from 'react-router-config';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import * as Actions from './Store/Actions/PrimeirosPassosActions';
import reducer from './Store/Reducers/PrimeirosPassosReducer';

const md = new MobileDetect(window.navigator.userAgent);

const CONTEUDOS = [
    {
        "conteudo": "1",
        "nome": "Meu perfil",
        "item": "meuperfil",
        "path": "conta/editarmeuperfil/<#ID#>"
    },
    {
        "conteudo": "2",
        "nome": "Serviços",
        "item": "empresaproduto",
        "path": "/<#ORGANIZACAO#>/<#EMPRESA#>/empresaproduto"
    },
    {
        "conteudo": "8",
        "nome": "Tags",
        "item": "empresatag",
        "path": "/<#ORGANIZACAO#>/<#EMPRESA#>/empresatag"
    },
    {
        "conteudo": "3",
        "nome": "Pessoas",
        "item": "empresapessoa",
        "path": "/<#ORGANIZACAO#>/<#EMPRESA#>/empresapessoa"
    },
    {
        "conteudo": "7",
        "nome": "Agendamentos",
        "item": "agendamento",
        "path": "/<#ORGANIZACAO#>/<#EMPRESA#>/agendamento/secretaria"
    },
    {
        "conteudo": "6",
        "nome": "Atendimentos",
        "item": "atendimento",
        "path": "/<#ORGANIZACAO#>/<#EMPRESA#>/minhastarefas/atendimentomedico"
    },
    {
        "conteudo": "4",
        "nome": "Fechamento de caixa",
        "item": "financeirofechamentocaixa",
        "path": "/<#ORGANIZACAO#>/<#EMPRESA#>/empresafinanceiro/caixaaberto"
    },
    {
        "conteudo": "5",
        "nome": "Conferência de caixa",
        "item": "financeiroconferenciacaixa",
        "path": "/<#ORGANIZACAO#>/<#EMPRESA#>/empresafinanceiro/caixa"
    },
    {
        "conteudo": "10",
        "nome": "Contas a receber",
        "item": "financeiroreceber",
        "path": "/<#ORGANIZACAO#>/<#EMPRESA#>/empresafinanceiro/areceber"
    },
    {
        "conteudo": "9",
        "nome": "Home",
        "item": "empresadashboard",
    },
];

function Transition(props) {
    return <Slide direction="up" {...props} />;
}

const styles = theme => ({
    toolbar: {
        background: theme.palette.type === 'dark' ? '#303030' : '#E6E6E6',
        borderRadius: "4px 4px 0 0"
    },
    btn: {
        position: "absolute",
        bottom: _.isNull(md.mobile()) && _.isNull(md.tablet()) ? 20 : 65,
        left: 20,
        zIndex: 10,
    },
    paperPainel: {
        position: 'absolute',
        left: 20,
        bottom: 70,
        bottom: _.isNull(md.mobile()) && _.isNull(md.tablet()) ? 70 : 115,
        zIndex: 10,
        maxHeight: "calc(100vh * .7)",
        width: 300
    },
    grupos: {
        position: 'relative',
        display: 'flex',
        overflow: 'auto',
        flex: '1 1 auto',
        flexDirection: 'column',
        width: '100%',
        '-webkit-overflow-scrolling': 'touch',
        zIndex: 2
    },
    conteudo: {
        paddingLeft: 8,
        paddingRight: 8,
        lineHeight: 1.6,
        '& p': {
            textIndent: "1.5em"
        },
        '& ol': {
            paddingLeft: 16
        }
    }
});

class PrimeirosPassos extends XAPPComponent {

    state = {
        grupo: null,
    };

    componentDidUpdate(prevProps, prevState) {
        if (this.props.reducer.error) {
            this.props.showMessage({
                message: this.props.reducer.error,
                variant: 'error'
            });
            this.props.reducer.error = null;
        }

        const { getJson, route = null, sistemas = null, reducer, empresa = null } = this.props;

        if (!_.isNull(route) && !_.isNull(sistemas) && !_.isNull(empresa) && !_.isUndefined(sistemas[empresa])) {
            var xappRouteParams = {};
            xappRouteParams.organizacao = sistemas[empresa].organizacao;
            xappRouteParams.empresa = empresa;
            let AIDConteudo = this.existsConteudo();
            if (!_.isNull(AIDConteudo) && !_.isNull(reducer.json) && !_.isEqual(AIDConteudo, reducer.json.idconteudo)) {
                getJson(AIDConteudo, xappRouteParams);
            }
        }

        if (!_.isNull(this.state.grupo) && !_.isEqual(prevProps.reducer.json, reducer.json)) {
            this.openGrupo();
        }
    }

    handleChange = (event) => {
        this.setState(_.set({ ...this.state }, event.target.name, event.target.value));
    };

    openGrupo = (_AValue) => {
        this.setState(_.set({ ...this.state }, "grupo", _AValue === this.state.grupo ? null : _AValue));
    }

    existsConteudo = () => {
        const { route = null, sistemas = null, empresa = null } = this.props;
        const { pathname } = document.location;
        let AIDConteudo = null;
        var ARoutes = [];
        if (pathname.split('/').length > 3 && !_.isUndefined(route[empresa])) {
            ARoutes = route[empresa];
        }
        else {
            ARoutes = route["user"];
        }
        var xappRouteParams = {};
        xappRouteParams.organizacao = sistemas[empresa].organizacao;
        xappRouteParams.empresa = empresa;

        let AMatched = matchRoutes(ARoutes, pathname);
        if (!_.isUndefined(AMatched) && !_.isNull(AMatched) && AMatched.length > 0) {
            AIDConteudo = AMatched[0].route.getStart;
        }
        return !_.isNull(AIDConteudo) ? Number(AIDConteudo) : AIDConteudo;
    }

    render() {
        const { classes, user, closePainel, getConteudo, getJson, route = null, sistemas = null, reducer, empresa = null, getDialog, closeDialog } = this.props;
        const form = this.state;

        if (!_.isNull(route) && !_.isNull(sistemas) && !_.isNull(empresa) && !_.isUndefined(sistemas[empresa])) {
            var xappRouteParams = {};
            xappRouteParams.organizacao = sistemas[empresa].organizacao;
            xappRouteParams.empresa = empresa;

            let AIDConteudo = this.existsConteudo();

            return (
                <React.Fragment>
                    {!_.isNull(AIDConteudo) && !_.isUndefined(user.dados) && !_.isUndefined(user.dados.treinamento) && user.dados.treinamento === 1 &&
                        <React.Fragment>
                            <FuseAnimate delay={300}>
                                <XAPPButton
                                    type="Button"
                                    className={clsx(classes.btn, "")}
                                    onClick={(ev) => {
                                        if (!_.isUndefined(reducer.json) && !_.isNull(reducer.json)) {
                                            this.openGrupo();
                                            closePainel();
                                        }
                                        else {
                                            getJson(AIDConteudo, xappRouteParams);
                                        }
                                    }}
                                    color="primary"
                                    variant="contained"
                                    iconProps={"text-white mr-8"}
                                    icon={"checklist"}
                                    label={"primeiros passos"}
                                    key={"btnPrimeirosPassos"}
                                />
                            </FuseAnimate>
                            {(!_.isUndefined(reducer.json) && !_.isNull(reducer.json)) &&
                                <FuseAnimate delay={300}>
                                    <Paper className={clsx(classes.paperPainel, 'flex flex-col')}>
                                        <div className='flex flex-row items-start'>
                                            {!_.isNull(reducer.json) &&
                                                <Typography className="inline font-medium font-bold p-4 text-13" paragraph={false}>
                                                    {reducer.json.mensagem}
                                                </Typography>
                                            }
                                            <div className='flex-1' />
                                            <XAPPButton
                                                type="Icon"
                                                onClick={(ev) => {
                                                    this.openGrupo();
                                                    closePainel();
                                                }}
                                                color="primary"
                                                variant="contained"
                                                className="p-6"
                                                icon={"close"}
                                                key={"iconClosePrimeirosPassos"}
                                            />
                                        </div>
                                        <Typography className="inline font-medium px-4 pb-8 text-13" paragraph={false}>
                                            {"Vamos começar?"}
                                        </Typography>
                                        {!_.isNull(reducer.json) &&
                                            <FuseScrollbars className={classes.grupos}>
                                                {reducer.json.grupos.map((item, x) => (
                                                    <div>
                                                        <div
                                                            className="flex px-4 items-center cursor-pointer"
                                                            onClick={() => {
                                                                if (form.grupo !== x) {
                                                                    getConteudo(item.idconteudo, xappRouteParams);
                                                                    this.openGrupo(x);
                                                                }
                                                                else {
                                                                    this.openGrupo();
                                                                }
                                                            }}
                                                        >
                                                            <Typography className="inline font-medium text-13" color="primary" paragraph={false}>
                                                                {item.nome}
                                                            </Typography>
                                                            <div className="flex-1" />
                                                            <XAPPButton
                                                                noHover={true}
                                                                className="p-6"
                                                                color="primary"
                                                                type="icon"
                                                                icon={form.grupo === x ? "arrow_up" : "arrow_down"}
                                                                onClick={() => { }}
                                                            />
                                                        </div>
                                                        <Collapse in={form.grupo === x} timeout="auto" unmountOnExit className="">
                                                            <div className={classes.conteudo} dangerouslySetInnerHTML={{ __html: !_.isNull(reducer.conteudo) ? reducer.conteudo : "" }}>
                                                            </div>
                                                            {!_.isUndefined(item.saibaMais) && !_.isNull(item.saibaMais) &&
                                                                <div className='flex w-full items-center justify-center'>
                                                                    <XAPPButton
                                                                        type="Button"
                                                                        className={clsx("mt-4")}
                                                                        onClick={(ev) => {
                                                                            getDialog(item.saibaMais, xappRouteParams);
                                                                        }}
                                                                        color="primary"
                                                                        variant="contained"
                                                                        iconProps={"text-white mr-8"}
                                                                        label={"Saiba mais"}
                                                                        key={"btnSaibaMais"}
                                                                    />
                                                                </div>
                                                            }
                                                        </Collapse>
                                                    </div>
                                                ))}
                                            </FuseScrollbars>
                                        }
                                    </Paper>
                                </FuseAnimate>

                            }
                            <XAPPDialog
                                id="PrimeirosPassos"
                                open={!_.isNull(reducer.dialog)}
                                onClose={() => closeDialog()}
                                aria-labelledby="knowledge-base-document"
                                TransitionComponent={Transition}
                                maxWidth="xl"
                                fullWidth
                            >
                                <DialogTitle>
                                    {!_.isNull(reducer.dialog) ? reducer.dialog.titulo : ""}
                                </DialogTitle>
                                <DialogContent>
                                    <div dangerouslySetInnerHTML={{ __html: !_.isNull(reducer.dialog) ? reducer.dialog.conteudo : "" }}>
                                    </div>
                                </DialogContent>
                                <AppBar position="static" elevation={3} color="textSecondary">
                                    <Toolbar className="flex w-full justify-end min-h-0">
                                        <DialogActions>
                                            <XAPPButton
                                                type="Button"
                                                onClick={() => closeDialog()}
                                                className="mr-8"
                                                variant="contained"
                                                color="primary"
                                                iconProps={""}
                                                icon={null}
                                                label={md.mobile() === null && md.tablet() === null ? 'Fechar' : ''}
                                            />
                                        </DialogActions>
                                    </Toolbar>
                                </AppBar>
                            </XAPPDialog>
                        </React.Fragment>
                    }
                </React.Fragment>
            )
        }
        else {
            return null
        }
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getJson: Actions.getJson,
        getConteudo: Actions.getConteudo,
        getDialog: Actions.getDialog,
        closeDialog: Actions.closeDialog,
        closePainel: Actions.closePainel,
        showMessage: AppActions.showMessage,
    }, dispatch);
}

function mapStateToProps({ PrimeirosPassos, auth, fuse }) {
    return {
        reducer: PrimeirosPassos,
        user: auth.user.data,
        sistemas: auth.user.data.settings.sistemas,
        route: auth.user.data.settings.route,
        empresa: fuse.navigation.empresa
    }
}

export default withReducer('PrimeirosPassos', reducer)(withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(PrimeirosPassos))));
